import React from 'react';
import ReactDOM from 'react-dom/client';
import { Global } from '@emotion/react';

import globalStyles from './styles/global';

import CardWalletApp from './CardWalletApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Global styles={globalStyles} />
    <CardWalletApp />
  </>,
);
